import { Switch, Route, Redirect } from 'react-router-dom';

import Dashboard from './Dashboard';
import ViewCustomers from './Customers/ViewCustomers';
import ViewCustomer from './Customers/ViewCustomer';
import ViewDeliveries from './Deliveries/ViewDeliveries';
import ViewDelivery from './Deliveries/ViewDelivery';
import ViewDeposits from './Deposits/ViewDeposits';
import ViewDeposit from './Deposits/ViewDeposit';
import ViewMultiDeposits from './Deposits/ViewMultiDeposits';
import ViewInventories from './Deposits/ViewInventories';
import ViewInventory from './Deposits/ViewInventory';
import ViewProducts from './Products/ViewProducts';
import ViewProduct from './Products/ViewProduct';
import EditProduct from './Products/EditProduct';
import NewProduct from './Products/NewProduct';
import ViewSells from './Sells/ViewSells';
import ViewSell from './Sells/ViewSell';
import FileSells from './Sells/FileSells';
import ViewTransfers from './Transfers/ViewTransfers';
import ViewTransfer from './Transfers/ViewTransfer';
import ViewUsers from './Users/ViewUsers';
import EditUser from './Users/EditUser';
import Profile from './Users/Profile';
import ViewRoles from './Users/ViewRoles';
import EditRole from './Users/EditRole';
import UploadInventoryFileEPH from './Files/UploadInventoryFileEPH';
import UploadTransfersFileEPH from './Files/UploadTransfersFileEPH';
import UploadProductsFileEPH from './Files/UploadProductsFileEPH';
import ViewReports from './Reports/ViewReports';
import ViewReportSells from './Reports/ViewReportSell';
import ViewReportInvoiced from './Reports/ViewReportInvoiced';
import ViewReportDeposits from './Reports/ViewReportDeposits';
import ViewReportStocks from './Reports/ViewReportStocks';
import ViewReportSellsGraph from './Reports/ViewReportSellsGraph';
import ViewReportEfficacy from './Reports/ViewReportEfficacy';
import ViewReportReplenishment from './Reports/ViewReportReplenishment';
import ViewLosses from './Losses/ViewLosses';
import ViewLeads from './Leads/ViewLeads';
import ViewLead from './Leads/ViewLead';

function RouterContainer() {
  return (
    <div>
      <Switch>
        <Route path="/" exact>
          <Redirect to="/dashboard" />
        </Route>

        <Route path="/dashboard">
          <Dashboard />
        </Route>

        <Route path="/profile">
          <Profile />
        </Route>

        {/* LEADS */}
        <Route path="/leads" exact>
          <ViewLeads />
        </Route>
        <Route path="/leads/page/:page" exact>
          <ViewLeads />
        </Route>
        <Route path="/leads/:id" exact>
          <ViewLead />
        </Route>

        {/* CUSTOMERS */}
        <Route path="/customers" exact>
          <ViewCustomers />
        </Route>
        <Route path="/customers/page/:page" exact>
          <ViewCustomers />
        </Route>
        <Route path="/customers/:id" exact>
          <ViewCustomer />
        </Route>

        {/* DELIVERIES */}
        <Route path="/deliveries" exact>
          <ViewDeliveries />
        </Route>
        <Route path="/deliveries/page/:page" exact>
          <ViewDeliveries />
        </Route>
        <Route path="/deliveries/:id">
          <ViewDelivery />
        </Route>

        {/* DEPOSITS */}
        <Route path="/deposits/page/:page" exact>
          <ViewDeposits />
        </Route>
        <Route path="/deposits" exact>
          <ViewDeposits />
        </Route>
        {/* Ha de ir antes de /deposits/:id o «multi» se interpretaría como un id */}
        <Route path="/deposits/multi" exact>
          <ViewMultiDeposits />
        </Route>
        <Route path="/deposits/:id/losses" exact>
          <ViewLosses />
        </Route>
        <Route path="/deposits/:id" exact>
          <ViewDeposit />
        </Route>

        {/* LOSSES (cross-deposit) */}
        <Route path="/losses" exact>
          <ViewLosses />
        </Route>

        {/* INVENTORIES */}
        <Route path="/inventories" exact>
          <ViewInventories all={true} />
        </Route>
        <Route path="/deposits/:depositId/inventories/:inventoryId">
          <ViewInventory />
        </Route>

        {/* FILES */}
        <Route path="/files/inventories/eph" exact>
          <UploadInventoryFileEPH />
        </Route>
        <Route path="/files/transfers/eph" exact>
          <UploadTransfersFileEPH />
        </Route>
        <Route path="/files/products/eph/upc" exact>
          <UploadProductsFileEPH />
        </Route>

        {/* PRODUCTS */}
        {/* <Route path="/products/files/eph" exact>
          <UploadProductsFileEPH />
        </Route> */}
        {/* /products/new va ANTES de /products/:id: si no, ViewProduct
            intentaría cargar el producto con id "new". */}
        <Route path="/products/new" exact>
          <NewProduct />
        </Route>
        <Route path="/products/:id/edit" exact>
          <EditProduct />
        </Route>
        <Route path="/products/:id" exact>
          <ViewProduct />
        </Route>
        <Route path="/products" exact>
          <ViewProducts />
        </Route>

        {/* REPORTS */}
        <Route path="/reports" exact>
          <ViewReports />
        </Route>
        <Route path="/reports/sells/eph" exact>
          <ViewReportSells
            title="Ventas en Palacio de Hierro"
            subtitle="Unidades vendidas por centro y serie"
            filters={{
              customers: {
                name: 'Clientes',
                slug: 'customers',
                value: '2',
              },
            }}
          />
        </Route>
        <Route path="/reports/sells/outlet" exact>
          <ViewReportSells
            title="Ventas en Outlet Lerma"
            subtitle="Unidades vendidas por serie"
            filters={{
              deposits: {
                name: 'Depósitos',
                slug: 'deposits',
                value: '45',
              },
            }}
            omitFilters={['deposits']}
          />
        </Route>
        <Route path="/reports/sells/graph" exact>
          <ViewReportSellsGraph />
        </Route>
        <Route path="/reports/invoiced" exact>
          <ViewReportInvoiced />
        </Route>
        {/* Valoración de existencias: la versión dinámica vive en /reports/stocks.
            El informe antiguo queda en /reports/deposits-old, fuera del menú,
            y la URL histórica redirige a la nueva. */}
        <Route path="/reports/stocks" exact>
          <ViewReportStocks />
        </Route>
        <Route path="/reports/deposits-old" exact>
          <ViewReportDeposits />
        </Route>
        <Route path="/reports/deposits" exact>
          <Redirect to="/reports/stocks" />
        </Route>
        <Route path="/reports/replenishment" exact>
          <ViewReportReplenishment />
        </Route>
        <Route path="/reports/efficacy" exact>
          <ViewReportEfficacy />
        </Route>

        {/* SELLS */}
        <Route path="/sells" exact>
          <ViewSells />
        </Route>
        <Route path="/sells/page/:page" exact>
          <ViewSells />
        </Route>
        <Route path="/sells/file">
          <FileSells />
        </Route>
        <Route path="/sells/:id" exact>
          <ViewSell />
        </Route>

        {/* TRANSFERS */}
        <Route path="/transfers" exact>
          <ViewTransfers />
        </Route>
        <Route path="/transfers/:id">
          <ViewTransfer />
        </Route>

        {/* USERS */}
        <Route path="/users/roles/:id">
          <EditRole />
        </Route>
        <Route path="/users/roles">
          <ViewRoles />
        </Route>
        <Route path="/users/:id/edit">
          <EditUser />
        </Route>
        <Route path="/users" exact>
          <ViewUsers />
        </Route>
        <Route path="/users/page/:page" exact>
          <ViewUsers />
        </Route>
      </Switch>
    </div>
  );
}

export default RouterContainer;
